import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const EjectIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 15 13.914"
    >
      <g transform="translate(1 1.414)">
        <path
          d="M13.109,263.75l6.5,6.494h-13l6.5-6.494"
          transform="translate(-6.609 -263.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x2="12.872"
          transform="translate(0.063 11.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
